/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { DEFAULT_DIALOG_CONFIG, Dialog, DIALOG_SCROLL_STRATEGY, DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { Inject, Injectable, Injector, Optional, SkipSelf, TemplateRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';

@Injectable({
    providedIn: 'root',
})
export class MeasureDialog extends Dialog {
    constructor(
        private overlay: Overlay,
        _injector: Injector,
        public injector: Injector,
        @Optional() @Inject(DEFAULT_DIALOG_CONFIG) _dialogConfig: DialogConfig,
        public _overlayContainerRef: OverlayContainer,
        @Inject(DIALOG_SCROLL_STRATEGY) scrollStrategy: any,
        @Optional() @SkipSelf() _parentDialog: Dialog,
        @Optional() public dialogRef: DialogRef<any>
    ) {
        super(overlay, _injector, _dialogConfig, _parentDialog, _overlayContainerRef, scrollStrategy);
    }

    /**
     * Open a custom component in an overlay
     */
    open<R, D, C>(
        componentOrTemplateRef: ComponentType<C> | TemplateRef<C>,
        config?: DialogConfig<D, DialogRef<R, C>>
    ): DialogRef<R, C> {
        const defaultSettings = {
            positionStrategy: this.overlay.position().global().bottom('10px').centerHorizontally(),
        };

        config = { ...config, ...defaultSettings };
        return super.open(componentOrTemplateRef, config);
    }
}
